import cookiebot from './cookiebot'

export default cookiebot
